import React from 'react';
import { formatCurrency, TrashIcon } from '@avila-tek/ui/src';
import { TEditShopCartInput } from '../../../hooks';
import { Client, ShopCartItem, User } from '../../../models';

interface EditEmployeeItem {
  user: User;
  type?: 'product' | 'plan' | 'benefit';
  quantity?: number;
  editShopCart?: (props: TEditShopCartInput) => void;
  shopItem?: ShopCartItem;
  price?: number;
}

function EditEmployeeItem({
  user,
  type,
  shopItem,
  editShopCart,
  quantity,
  price,
}: EditEmployeeItem) {
  const [value, setValue] = React.useState<number>(quantity);

  const onChange = (_value: number) => {
    if (type === 'benefit') {
      editShopCart({
        shopItem,
        productType: type,
        newQuantity: _value,
        client: (user.client as Client)._id,
        ...(type === 'benefit' && { benefitPrice: price }),
      });
    } else {
      editShopCart({
        shopItem,
        productType: type,
        newQuantity: _value,
        client: (user.client as Client)._id,
      });
    }
    setValue(_value);
  };

  return (
    <div className="w-full flex justify-between mt-3 items-center h-10 pl-2">
      <span>
        {user?.firstName} {user?.lastName}
      </span>

      {type === 'product' || type === 'benefit' ? (
        <div className="flex flex-row h-10  rounded-lg relative bg-transparent mt-1">
          <button
            type="button"
            className="  text-gray-600 h-full w-10 rounded-l cursor-pointer outline-none"
            onClick={(e) => {
              e.preventDefault();
              onChange(value - 1);
            }}
          >
            <span className="m-auto text-2xl text-neutral-cold-400">−</span>
          </button>
          <span className=" flex justify-center  focus:outline-none text-center w-full font-semibold text-md hover:text-black focus:text-black  md:text-base cursor-default items-center text-neutral-cold-400 outline-none">
            <span className="text-purple-300 font-semibold">
              ${formatCurrency(price)}
            </span>{' '}
            <span className="ml-1"> x {value ?? 0}</span>
          </span>

          <button
            type="button"
            className=" text-gray-600  h-full w-10 rounded-r cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              onChange(value + 1);
            }}
          >
            <span className="m-auto text-2xl text-neutral-cold-400 ">+</span>
          </button>
        </div>
      ) : (
        <TrashIcon
          className="w-6 h-6 text-neutral-cold-400 cursor-pointer hover:text-danger-200"
          onClick={(e) => {
            e.preventDefault();
            onChange(value - 1);
          }}
        />
      )}
    </div>
  );
}

export default EditEmployeeItem;
